import clsx from "clsx";

import { Icon } from './Icon';
import Level1DepartmentIcon from './Level1DepartmentIcon.png';
import Level2DepartmentIcon from './Level2DepartmentIcon.png';
import Level3DepartmentIcon from './Level3DepartmentIcon.png';
import { INodeData } from "./types";
import { getStyles } from "./utils";

interface INodeProps {
  nodeData: INodeData;
}

export const Node = ({ nodeData: { isFirst, isLast, name, _children } }: INodeProps) => {
  const styles = getStyles();

  return (
    <div>
      <div className={clsx(styles.node, "node-custom")}>
        <Icon src={isFirst ? Level1DepartmentIcon : Level2DepartmentIcon} lvl={isFirst ? 'first' : 'second'} />
        <div className={clsx(styles.name, isFirst && styles.first )}>
          {name}
        </div>
      </div>
      {isLast && _children && (
        <div className={styles['children-container']}>
          {_children.map(({ id, name }) => (
            <div key={id} className={clsx(styles.node, "node-custom")}>
              <Icon src={Level3DepartmentIcon} lvl="third" />
              <div className={styles.name}>
                {name}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
